__turbopack_context__.v({
  "selected": "TagsFilter-module-scss-module__fMz9sW__selected",
  "tag": "TagsFilter-module-scss-module__fMz9sW__tag",
  "tagsContainer": "TagsFilter-module-scss-module__fMz9sW__tagsContainer",
});
